<template>
  <BasePageWrapper title="PAGE NOT FOUND" title-align="center"> </BasePageWrapper>
</template>
<script>
export default {
  name: "Error404",
};
</script>
